import store from 'Redux/store';
import { itemsToApplyVoucherTo } from 'Reselects/cartcalc';

export function findValidDelivery(product, deliveries) { // eslint-disable-line
  if (!product) {
    return null;
  }

  const valid = deliveries.find((delivery) => {
    const { voucherApplyArray } = itemsToApplyVoucherTo({
      voucher: delivery,
      pickAndMixAll: store.getState().pickAndMix.all,
      cartItems: [product],
    });

    if (voucherApplyArray.filter(prod => prod._id === product._id).length) {
      return true;
    }

    return false;
  });

  return valid;
}
